import { ReactNode } from "react";
import { LanguageSelector } from "@/shared/widgets/language-selector";

interface AuthLayoutProps {
  children: ReactNode;
  className?: string;
}

export function AuthLayout({ children, className = "" }: AuthLayoutProps) {
  return (
    <div className={`min-h-screen bg-[#1A1A1A] flex items-center justify-center p-4 relative ${className}`}>
      {/* Seletor de idioma no canto superior direito */}
      <div className="absolute top-4 right-4">
        <LanguageSelector />
      </div>
      {children}
    </div>
  );
}
